const form_template = `
    <div class='row'>
        <div class='col-lg-12'>
            <amt-form-inline
                name='segments.EventSegmentsForm'
                on-submit='updateCharts(model)'
                extend-model='$root.chartParams.filters'
            >
            </amt-form-inline>
        </div>
    </div>
`;
const form_view = {
    template: form_template,
    controller: [
        '$scope',
        'chartFilters',
        'toaster',
        function($scope, chartFilters, toaster) {
            var notify = function(title, type) {
                toaster.pop({type: type, title: title, timeout: 2500});
            }
            var model = chartFilters.get_chart_filters();
            if (!model.filters.missions) {
                notify('Missions filter is required', 'info');
                $scope.isOpened = true;
            }
            $scope.updateCharts = function(filters) {
                if (!filters.missions) {
                    notify('Missions filter is required', 'error');
                    return
                }
                $scope.$parent.updateCharts(filters)
            };
        },
    ],
};
const form_ctrl = form_view.controller;

export {
     form_ctrl,
};
export default form_view;
